(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

jQuery(document).ready(function ($) {
  /**
   * This is calling after submit search form.
   */
  jQuery("form.term_meta").on('submit', function (event) {
    event.preventDefault(); // Prevent the default form submit.

    $("input#title").val(''); // Clear Input title,

    console.log($(document).find("form.term_meta").data('data-first'));

    // This part check if this is first time search and send info to php to delete transient.
    if ($(document).find("form.term_meta").val('data-first') === 0) {
      var first = 0;
    } else {
      $(document).find("form.term_meta").data('data-first', '1');
      var first = 1;
    }
    var ajax_form_data = {};
    $.each($('form.term_meta').serializeArray(), function () {
      ajax_form_data[this.name] = this.value;
    });
    ajax_form_data.page_number = 1;
    ajax_form_data.first = first;
    $.ajax({
      url: params.ajaxurl,
      // domain/wp-admin/admin-ajax.php
      method: 'POST',
      data: {
        action: 'send_question',
        ajax_form_data: ajax_form_data,
        beforeSend: function beforeSend() {
          loader_start();
        }
      }
    })
    // when all is OK
    .done(function (response) {
      // response from the PHP action
      response = JSON.parse(response); // Decode json response from SearchController

      loader_stop();
      show_result(response.text);
    })

    // something went wrong
    .fail(function (jqXHR, error, errorThrown) {
      jsonValue = jQuery.parseJSON(jqXHR.responseText);
      console.log(jsonValue.Message);
    })

    // after all this time?
    .always(function () {
      // event.target.reset();
      $("select#meta").prop('disabled', true);
      $("form.term_meta")[0].reset();
    });
  });

  /**
   * This is calling after submit Title search form.
   */
  jQuery("form.title").on('submit', function (event) {
    event.preventDefault(); // Prevent the default form submit.

    var title_text = $('input#title').val();
    var custom_nonce = $('input#nonce').val();
    if (!title_text.trim()) {
      return;
    }
    $.ajax({
      url: params.ajaxurl,
      // domain/wp-admin/admin-ajax.php
      method: 'POST',
      data_type: 'json',
      data: {
        action: 'title_question',
        search_text: title_text,
        custom_nonce: custom_nonce,
        page_number: 1
      },
      beforeSend: function beforeSend() {
        loader_start();
      }
    })
    // when all is OK
    .done(function (response) {
      // response from the PHP action
      response = JSON.parse(response); // Decode json response from SearchController
      loader_stop();
      if (response !== "0" && response.status !== 'error') {
        $("#search-result").removeClass('error');
        show_result(response.text);
      } else {
        $("#search-result").addClass('error');
        show_result(response.text);
      }
    })
    // something went wrong
    .fail(function (jqXHR, error, errorThrown) {
      jsonValue = jQuery.parseJSON(jqXHR.responseText);
      console.log(jsonValue.Message);
    });
  });

  /**
   * This is calling after click change page +
   */
  jQuery(document).on('click', '#next-page', function (event) {
    event.preventDefault(); // Prevent the default form submit.
    var data_out = {};
    var title_text = $('input#title').val();
    var custom_nonce = $('input#nonce').val();
    var page = $("#result-paged").data('page');
    var max_page = $("div#result-paged").data('max-page');
    var callback = $('#result-paged').data('callback');

    // This set is not first search.
    $(document).find("form.term_meta").attr('data-first', '0');
    page++; //Heart of this bussiness

    if (callback === 'send_question') {
      var ajax_data = {
        action: callback,
        // Go to the proper callback
        custom_nonce: custom_nonce,
        page_number: page,
        term_id: 30,
        city: ''
      };
      data_out = {
        action: callback,
        ajax_form_data: ajax_data
      };
    }
    if (callback === 'title_question') {
      var data_out = {
        action: callback,
        // Go to the proper callback
        search_text: title_text,
        custom_nonce: custom_nonce,
        page_number: page
      };
    }

    // if ( page > max_page || !title_text) {
    if (page > max_page) {
      return;
    }
    $.ajax({
      url: params.ajaxurl,
      // domain/wp-admin/admin-ajax.php
      method: 'POST',
      data_type: 'json',
      data: data_out,
      beforeSend: function beforeSend() {
        // loader_start();
      }
    })
    // when all is OK
    .done(function (response) {
      // response from the PHP action
      response = JSON.parse(response); // Decode json response from SearchController
      // loader_stop();

      if (response !== "0" && response.status !== 'error') {
        $("#search-result").removeClass('error');
        show_result(response.text);
      } else {
        $("#search-result").addClass('error');
        show_result(response.text);
      }
    })
    // something went wrong
    .fail(function (jqXHR, error, errorThrown) {
      jsonValue = jQuery.parseJSON(jqXHR.responseText);
      console.log(jsonValue.Message);
    });
  });

  /**
   * This is calling after click change page -
   */
  jQuery(document).on('click', '#prev-page', function (event) {
    event.preventDefault(); // Prevent the default form submit.

    var data_out = {};
    var title_text = $('input#title').val();
    var custom_nonce = $('input#nonce').val();
    var page = $("#result-paged").data('page');
    var max_page = $("div#result-paged").data('max-page');
    var callback = $('#result-paged').data('callback');

    // This set is not first search.
    $(document).find("form.term_meta").attr('data-first', '0');
    page = page - 1;
    if (page < 1) {
      $("a#next-page").css('pointer-events', 'auto');
      page = 1;
    }
    if (callback === 'title_question') {
      var data_out = {
        action: callback,
        // Go to the proper callback
        search_text: title_text,
        custom_nonce: custom_nonce,
        page_number: page,
        first: 0
      };
    }
    if (callback === 'send_question') {
      var ajax_data = {
        action: callback,
        // Go to the proper callback
        custom_nonce: custom_nonce,
        page_number: page,
        term_id: 30,
        city: '',
        first: 0
      };
      data_out = {
        action: callback,
        ajax_form_data: ajax_data
      };
    }
    $.ajax({
      url: params.ajaxurl,
      // domain/wp-admin/admin-ajax.php
      method: 'POST',
      data_type: 'json',
      data: data_out,
      beforeSend: function beforeSend() {
        // loader_start();
      }
    })
    // when all is OK
    .done(function (response) {
      // response from the PHP action
      response = JSON.parse(response); // Decode json response from SearchController
      // loader_stop();

      if (response !== "0" && response.status !== 'error') {
        $("#search-result").removeClass('error');
        show_result(response.text);
      } else {
        $("#search-result").addClass('error');
        show_result(response.text);
      }
    })
    // something went wrong
    .fail(function (jqXHR, error, errorThrown) {
      jsonValue = jQuery.parseJSON(jqXHR.responseText);
      console.log(jsonValue.Message);
    });
  });

  /**
   * Clear response div after input title is changed.
   */
  jQuery("input#title").on('input', function (event) {
    var timerid;
    event.preventDefault(); // Prevent the default form submit.
    var value = $(this).val();
    if ($(this).data("lastval") != value) {
      $(this).data("lastval", value);
      clearTimeout(timerid);
      timerid = setTimeout(function () {
        //your change action goes here
        $("form.term_meta")[0].reset();
        clear_result();
      }, 500);
    }
  });

  /**
   * After term is changed.
   */
  jQuery("select#term_id").on('change', function (event) {
    event.preventDefault(); // Prevent the default form submit.

    $("input#title").val(''); // Clear title value

    var option_id = $('select#term_id').val();
    var custom_nonce = $('input#nonce').val();
    $.ajax({
      url: params.ajaxurl,
      // domain/wp-admin/admin-ajax.php
      method: 'POST',
      data_type: 'json',
      data: {
        action: 'send_option',
        data: option_id,
        nonce: custom_nonce
      },
      beforeSend: function beforeSend() {
        clear_result();
        loader_start();
      }
    })
    // when all is OK
    .done(function (response) {
      // response from the PHP action

      response = JSON.parse(response); // Decode json response from SearchController::metaFormTerm

      loader_stop();
      if (response !== "0" && response.status !== 'error') {
        $("#search-result").removeClass('error');
        $("input#term_meta").prop('disabled', false);
        $("select#meta").prop('disabled', false).html(response.text);
      } else {
        $("#search-result").addClass('error');
        show_result(response.text);
        $("input#term_meta").prop('disabled', true);
        $("select#meta").prop('disabled', true);
      }
    })
    // something went wrong
    .fail(function (jqXHR, error, errorThrown) {
      jsonValue = jQuery.parseJSON(jqXHR.responseText);
      console.log(jsonValue.Message);
    });
  });
  function loader_start() {
    $("#search-result").hide().html(''); // Clear search window content.
    $("form").css('opacity', 0.2); // Change opacity div form
    $('.loader').css('opacity', 1).show(); // Show loader
  }

  function loader_stop() {
    $(".loader").toggle(); // Hide loader
    $("form").css('opacity', 1);
  }
  function clear_result() {
    $("#search-result").fadeOut(250, function () {
      $("#search-result").html('');
    });
  }
  function show_result(response) {
    $("#search-result").html(response).fadeIn(1250);
  }
});

},{}]},{},[1]);
